// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgPurpleAvatar = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <g clipPath="url(#purpleAvatar_svg__a)">
      <path
        d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Z"
        fill="#FCF7F5"
      />
      <circle cx={12.143} cy={8.143} r={5.143} fill="#9865FC" />
      <path
        d="M1 26c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11S1 32.075 1 26Z"
        fill="#9865FC"
      />
      <path
        d="m18.979 15.736 2.735 1.121-2.735 1.122-1.121 2.735-1.123-2.735L14 16.857l2.735-1.121L17.858 13l1.12 2.736Z"
        fill="#FFC103"
      />
    </g>
    <defs>
      <clipPath id="purpleAvatar_svg__a">
        <path
          d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Z"
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgPurpleAvatar
